import type { ShipiumOauthClient, CreateOauthClientResponse, ShipiumApiKey } from './types';
import GatewayAxiosClient from '../GatewayAxiosClient';
import { getToken } from '../../session';
export class SecurityService {
  public async getPartnerOauthClients(partnerId: string): Promise<ShipiumOauthClient[]> {
    const res = await GatewayAxiosClient.get(`oauth/clients/${partnerId}`, {
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }
  public async createPartnerOauthClient(partnerId: string, name: string): Promise<CreateOauthClientResponse> {
    const res = await GatewayAxiosClient.post(
      `oauth/clients/${partnerId}`,
      { name },
      {
        headers: {
          authorization: getToken(),
        },
      },
    );
    return res.data;
  }
  public async resetPartnerOauthClient(
    partnerId: string,
    client: ShipiumOauthClient,
  ): Promise<CreateOauthClientResponse> {
    const res = await GatewayAxiosClient.put(`oauth/clients/${partnerId}/resetSecret`, client, {
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }
  public async updatePartnerOauthClient(partnerId: string, client: ShipiumOauthClient): Promise<ShipiumOauthClient> {
    const res = await GatewayAxiosClient.put(`oauth/clients/${partnerId}`, client, {
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }

  public async getAuthorities(): Promise<any> {
    const res = await GatewayAxiosClient.get(`/oauth/authorities`, {
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }
  public async createPartnerApiKey(partnerId: string, name: string): Promise<ShipiumApiKey> {
    const res = await GatewayAxiosClient.post(
      `/apiKey/${partnerId}`,
      { name },
      {
        headers: {
          authorization: getToken(),
        },
      },
    );
    return res.data;
  }
  public async updatePartnerApiKey(partnerId: string, updatedKey: ShipiumApiKey): Promise<ShipiumApiKey> {
    const res = await GatewayAxiosClient.put(`/apiKey/${partnerId}/${updatedKey.apiKeyId}`, updatedKey, {
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }
  public async getApiKeys(partnerId: string): Promise<ShipiumApiKey[]> {
    const res = await GatewayAxiosClient.get(`/apiKey/${partnerId}`, {
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }
}
